/**
 * Copyright Mántum All Rights Reserved.
 */
import { useCallback, useState } from 'react';
import { validator } from '@mantum/kanela';

export default (optional = false, initial = false) => {
    const [value, setValue] = useState(initial);

    const validate = useCallback(
        (value?: string) => {
            let result = true;
            if (!optional) {
                result = validator.isEmpty(value);
                setValue(result);
                result = !result;
            }
            return result;
        },
        [optional]
    );

    const clear = useCallback(() => {
        setValue(false);
    }, []);

    return {
        clear,
        validate,
        value
    };
};
